import { sendGoogleEvent } from '@html/_common/utils';

import AOCarousel from '@atomic/organisms/_common/carousel/carousel';

export default function initiatePlacesYouWillSee(eventCategory) {
  const placesCarousel = new AOCarousel('.js-ao-tour-places-you-will-see__carousel');
  const eventAction = 'Places';

  $('body').on('click', '.js-ao-tour-places-you-will-see__image', () => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Click Thumbnail',
    );
  });

  placesCarousel.onScrollAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Scroll',
    );
  });
  placesCarousel.onLeftClickAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Previous',
    );
  });
  placesCarousel.onRightClickAnalytics(() => {
    sendGoogleEvent(
      eventCategory,
      eventAction,
      'Next',
    );
  });

  placesCarousel.initiate();
}
